import { useState, useCallback } from "react";
import {
  getCollaborations,
  createCollaboration,
  updateCollaboration,
  deleteCollaboration,
  respondToCollaboration,
  deactivateCollaboration,
  activateCollaboration,
  getCollaborationsSummary,
  getCollaborationThread,
  reviewCollaboration,
  updateCollaborationSLA,
} from "../../../../api/marketplace";

export function useCollaborations() {
  const [collaborations, setCollaborations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [summary, setSummary] = useState(null);

  const fetchCollaborations = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getCollaborations(params);
      setCollaborations(res.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchSummary = useCallback(async () => {
    try {
      const res = await getCollaborationsSummary();
      setSummary(res.data);
    } catch (err) {
      console.error("Failed to fetch collaborations summary:", err);
    }
  }, []);

  const fetchThread = useCallback(async (id) => {
    const res = await getCollaborationThread(id);
    return res.data;
  }, []);

  const create = useCallback(async (data) => {
    const res = await createCollaboration(data);
    await fetchCollaborations();
    return res.data;
  }, [fetchCollaborations]);

  const update = useCallback(async (id, data) => {
    const res = await updateCollaboration(id, data);
    await fetchCollaborations();
    return res.data;
  }, [fetchCollaborations]);

  const remove = useCallback(async (id) => {
    const res = await deleteCollaboration(id);
    await fetchCollaborations();
    return res.data;
  }, [fetchCollaborations]);

  const respond = useCallback(async (id, data) => {
    const res = await respondToCollaboration(id, data);
    await fetchCollaborations();
    return res.data;
  }, [fetchCollaborations]);

  const deactivate = useCallback(async (id) => {
    const res = await deactivateCollaboration(id);
    await fetchCollaborations();
    return res.data;
  }, [fetchCollaborations]);

  const activate = useCallback(async (id) => {
    const res = await activateCollaboration(id);
    await fetchCollaborations();
    return res.data;
  }, [fetchCollaborations]);

  const review = useCallback(async (id, data) => {
    const res = await reviewCollaboration(id, data);
    return res.data;
  }, []);

  const updateSLA = useCallback(async (id, data) => {
    const res = await updateCollaborationSLA(id, data);
    return res.data;
  }, []);

  return {
    collaborations,
    loading,
    error,
    summary,
    fetchCollaborations,
    fetchSummary,
    fetchThread,
    create,
    update,
    remove,
    respond,
    deactivate,
    activate,
    review,
    updateSLA,
    setCollaborations,
  };
}
